import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { error } from 'toastr';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { FormControl, FormGroup } from '@angular/forms';
import { CommonService } from '../../../../../shared/services/common.service';
import { IAProposal } from '../../../../../shared/models/IAProposal';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { ToastrService } from 'ngx-toastr';
import { ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PreviewfileComponent } from '../../../previewfile/previewfile.component';


import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-iaproposalpage',
  templateUrl: './iaproposalpage.component.html',
  styleUrl: './iaproposalpage.component.css'
})
export class IaproposalpageComponent implements AfterViewInit, OnDestroy {

  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();

  dataMySource!: MatTableDataSource<IAProposal>
  /*commented by rp*/
  //displayedColumns: string[] = ['Sr.No', 'createdProposalId', 'shortNameOfOrganisation', 'dateofSubmission', 'interventionName', 'componentName','targetMSME', 'totalEventCount', 'status', 'remarks', 'Action', 'Download', 'Proposal' ]
  //added by rp
  displayedColumns: string[] = ['Sr.No', 'createdProposalId', 'shortNameOfOrganisation', 'dateofSubmission', 'interventionName', 'componentName', 'targetMSME', 'approvedTargetMSME', 'balanceTargetMSME', 'totalEventCount', 'status', 'remarks', 'Action', 'Download', 'Proposal']
  /*rp ends*/
  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';

  iaProposalForm: FormGroup;
  totalRegistered: number = 0;
  pendingVerification: number = 0;
  approvedRegistration: number = 0;
  rejectedRegistration: number = 0;
 

  allrecord: any[] = [];
  //dataSource: any[] = []; // Your full data source
  totalItems: number = 0; // Example total items
  pageSizeOptions: number[] = [10, 20, 50, 100];  // Available page sizes
  constructor(private router: Router, private apiService: ApiService, public dialog: MatDialog,
    private toastrService: ToastrService, public commonService: CommonService) {
    this.iaProposalForm = new FormGroup({
      search: new FormControl('')
    });
  }

  NewProposal() {
    this.router.navigate(['/proposal']);


  }
  ProposalList: any = []
  length: number = 0;
  pageSize: number = 20;
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  itemsPerPage: number = 20;
  isDisabled = true;
  IsProposalStatus = true;
  isSearchDisabled: boolean = true;
  isProposalStatusMessageHidden = false;

  ToDate: string = ''; //= '2024-12-04 00:00:00.000';
  currentDate: string = ''; //= '2024-12-05 00:00:00.000';
  DtoPagination =
    {
      "UserId": sessionStorage.getItem("iauserid"),
      "status": sessionStorage.getItem("status"),
      "PageNumber": 1,
      "PageSize": 10,
      "SortColumn": "",
      "SortDirection": "DESC",
      "SearchTerm": "",
      "SearchCol": ""
    }


  async ngOnInit(): Promise<void> {
    this.DtoPagination.PageSize = 20;
    this.DtoPagination.SearchTerm = this.commonService.searchText;
    this.DtoPagination.status = sessionStorage.getItem("status");

  }

  onSubmit() {
    this.DtoPagination.SearchTerm = this.iaProposalForm.get('search')?.value;
    this.LoadDetails();
  }
  //ngAfterViewInit() {
  //  this.LoadDetails();
  //}

  async ngAfterViewInit() {
    if (!this.sort) {
      console.error("MatSort is not initialized!");
      return;
    }
    this.LoadDetails();
  }

  

  LoadDetails() {
    if (!this.pagination) return;

    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadDataSubscription.unsubscribe();

    // Reset subscription with a new request
    this.loadDataSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;
          this.DtoPagination.status = sessionStorage.getItem("status");
          return this.apiService.getRequest(API_ENDPOINTS.IA.GETIAPROPOSALLISTbyStatus, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {


            const status = sessionStorage.getItem('status');

switch (status) {
  case 'Approved':
    this.length = resp.data.item1.approvedCount;
    break;

  case 'Pending':
    this.length = resp.data.item1.pendingCount;
    break;

  case 'Rejected':
    this.length = resp.data.item1.rejectedCount;
    break;

  default:
    this.length = resp.data.item1.totalCount;
    break;
}

            this.IsProposalStatus = resp.data.item1.proposalStatus==1?true:false;
            this.isProposalStatusMessageHidden = this.IsProposalStatus;
            // this.length = resp.data.item1.totalCount;
            this.totalItems = resp.data.item1.totalCount;
            this.totalRegistered = resp.data.item1.totalCount;
            this.pendingVerification = resp.data.item1.pendingCount;
            this.approvedRegistration = resp.data.item1.approvedCount;
            this.rejectedRegistration = resp.data.item1.rejectedCount;
            //console.log(resp?.data.item2);
            return resp?.data.item2 || {};




            
          }
        })
      )
      .subscribe(data => {
        this.dataMySource = data;
        this.adjustPaginator();
      });
  }

  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }


  adjustPaginator() {
    
    const totalPages = Math.ceil(this.length / this.pageSize);
    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }
  
   

  onSearchChange(e: any) {
    this.DtoPagination.SearchTerm = e.target.value;
    this.DtoPagination.PageNumber = 1;
    this.LoadDetails();
  }

  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;

  onPageChange(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.LoadDetails();
  }

  redirectToProposalPage(ProposalUserId: any): void {

    // Ensure the ProposalId is available
    if (!ProposalUserId) {
      this.toastrService.warning('ProposalId is missing!', 'Warning');
      return;
    }

    // Optionally, fetch additional data related to the proposal using the ProposalId
    this.apiService.getRequest(API_ENDPOINTS.IA.GETPROPOSALSUBMISSIONDETAILS, { ProposalUserId: ProposalUserId }).subscribe(
      (response: any) => {
        // Check if the response contains the expected data
        //if (response.status && response.totalRecords > 0) {
        if (response.status && response.data != null) {

          // Store proposal data in localStorage (or use state management if preferred)
          localStorage.setItem('proposalDetails', JSON.stringify(response.data));
          localStorage.setItem('ProposalUserId', ProposalUserId);
          // Navigate to the proposal page using ProposalId
          this.router.navigate(['/proposal', ProposalUserId]);
        } else {
    
          // Handle invalid or missing response data
          this.toastrService.warning('No record found', 'Warning');
        }
      },
      (error) => {
        // Handle errors during the API call
        this.toastrService.error('Failed to fetch proposal details', 'error');        
      }
    );
  }


  //action(proposalUserId: string, action: string): void {
  //  // Implement approval logic here
  //  this.router.navigate(['/proposalverificationdetails', proposalUserId, action]);
  //}

  //verify(proposalUserId: number, action: string): void {
  //  // Implement rejection logic here
  //  this.router.navigate(['/proposalverificationdetails', proposalUserId, action]);
  //}

  onCreateEvent(proposaluserid: any) {
    this.router.navigate(['/iaeventcreate', proposaluserid]);
  }

  onViewProposal(proposalUserId: string, action: string): void {
    // Implement approval logic here
    this.router.navigate(['/proposalverificationdetails', proposalUserId, action]);
  }
  
  onDownload(filePath: string, fileName: string) {
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }

  onSearchClick(searchValue: string): void {
    const searchControl = this.iaProposalForm.get('search');
    searchControl?.markAsTouched();
    if (searchControl?.valid && searchValue.trim() !== '') {
      this.DtoPagination.SearchTerm = searchValue.trim();
      this.DtoPagination.SearchCol = this.commonService.searchText;
      this.LoadDetails();
    }
  }
  
  resetPage() {
    this.DtoPagination.SearchTerm = "";
    this.DtoPagination.SearchCol = this.commonService.searchText;
    this.LoadDetails();
  }

  exportToExcel(): void {
    const fileName = 'Proposal_List.xlsx';

    const DtoPagination = {
      UserId: sessionStorage.getItem("iauserid"),
      PageNumber: 1,
      PageSize: 9999999,
      SortColumn: this.sort.active,
      SortDirection: this.sort.direction,
      SearchTerm: "",
      SearchCol: this.commonService.searchText,
    };

    this.apiService.getRequest(API_ENDPOINTS.IA.GETIAPROPOSALLIST, DtoPagination).subscribe(
      result => {
        if (result.status) {
          this.allrecord = result.data.item2;

          if (!this.allrecord || this.allrecord.length === 0) {
            this.toastrService.error('No data available to export.');
            return;
          }

          const excelData = this.allrecord.map((item, index) => ({
            'Sr.No': item.rowNum,
            //'Proposal Id': item.proposalId,
            'IA Name': item.shortNameOfOrganisation,
            'Submission Date': item.dateofSubmission,
            'Intervention': item.interventionName,
            'Component': item.componentName,
            'Total Event': item.totalEventCount,
            'Status': item.status,
            'Remarks': item.remarks,
            'Download': item.documentPath ? 'Available' : 'Not Available',
          }));

          const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

          const columnWidths = [
            { wch: 10 }, // Sr.No            
            //{ wch: 15 }, // Proposal Id
            { wch: 25 }, // IA Name
            { wch: 20 }, // Submission Date
            { wch: 20 }, // Intervention
            { wch: 20 }, // Component
            { wch: 15 }, // Total Event
            { wch: 15 }, // Status
            { wch: 30 }, // Remarks
            { wch: 15 }, // Download Status
          ];
          worksheet['!cols'] = columnWidths;

          const workbook: XLSX.WorkBook = {
            Sheets: { 'Proposal List': worksheet },
            SheetNames: ['Proposal List'],
          };

          const excelBuffer: any = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
          });

          const data: Blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
          });

          saveAs(data, fileName);
          this.toastrService.success('Excel exported successfully!');
        }
      }
    );
  }




  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }


  openFilePreviewDialog(filePath : string, fileName:string): void {
    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(PreviewfileComponent, {
          width: '80%',
          height: '80',
          data: { fileUrl, fileName }
        });
      }
    });
  }

}

